import { Collection } from 'firestorter';

import Collections from '../utils/collections';
import { firestorePaths } from '../utils/paths';
import BaseDocument from './BaseDocument';

export const TrackAssignmentStatus = {
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED',
  REMOVED: 'REMOVED',
};

class TrackAssignment extends BaseDocument {
  constructor(id, opts) {
    super(`${Collections.TRACK_ASSIGNMENT}/${id}`, opts);
  }

  get userId() {
    return this.data.userId;
  }

  get trackId() {
    return this.data.trackId;
  }

  get trackName() {
    return this.data.trackName;
  }

  get programs() {
    return this.data.programs || [];
  }

  get currentProgramIndex() {
    return this.data.currentProgramIndex ?? 0;
  }

  get status() {
    return this.data.status;
  }

  get assignedAt() {
    return this.data.assignedAt;
  }

  get lastProgramId() {
    return this.data.lastProgramId;
  }

  get lastProgramEndAt() {
    return this.data.lastProgramEndAt;
  }

  get source() {
    return this.data.source;
  }

  get coachId() {
    return this.data.coachId;
  }

  static async getTrackAssignmentsByUser(userId, coachId) {
    const collection = new Collection(firestorePaths.TRACK_ASSIGNMENT, {
      query: (ref) => ref
        .where('userId', '==', userId)
        .where('coachId', '==', coachId)
        .orderBy('assignedAt', 'asc'),
      createDocument: ({ id }, options) => new TrackAssignment(id, options),
    });
    await TrackAssignment.initCollection(collection);
    return collection;
  }
}

export default TrackAssignment;
